export default __webpack_public_path__ + "2547aaa0f7a632142c298c7e10c88561.svg";